module.exports = __webpack_public_path__ + "img/telegram2.808fa34a.svg";